import React from "react";
import RecentPostWidget from "../Widget/RecentPostWidget";

const recentPostData = [
  {
    title: `Can’t Conceive Naturally? IVF and ICSI Might Be the Key`,
    author: "Dr. Archana Srivastava",
    date: "14 May, 2025",
    href: "/can-not-conceive-naturally-IVF-and-ICSI-Might-Be-the-Key",
  },
  {
    title: `Jabalpur IVF Center: Pioneering Advanced Fertility Solutions for Couples`,
    author: "Dr. Archana Srivastava",
    date: "06 May, 2025",
    href: "/best-fertility-clinic-jabalpur-ivf-treatment",
  },
  {
    title: `Best Treatment for Oligospermia – Jabalpur Fertility Centre`,
    author: "Dr. Archana Srivastava",
    date: "24 April, 2025",
    href: "/best-treatment-for-oligospermia",
  },
  {
    title: `Best Gynecologist and Obstetrician in Jabalpur – Dr. Archana Shrivastava`,
    author: "Dr. Archana Srivastava",
    date: "14 April, 2025",
    href: "/best-gynecologist-obstetrician-jabalpur",
  },
  {
    title: `Male Infertility Treatment in Jabalpur: Meet the Best Doctors for Fertility Solutions`,
    author: "Dr. Archana Srivastava",
    date: "21 March, 2025",
    href: "/Male-Infertility-Treatment-in-Jabalpur-Meet-the-Best-Doctors-for-Fertility-Solutions",
  },
  {
    title: `Meet the Best IVF Doctor & Infertility Specialist in Jabalpur: Your Path to Parenthood`,
    author: "Dr. Archana Srivastava",
    date: "12 March, 2025",
    href: "/Meet-the-Best-IVF-Doctor-and-Infertility-Specialist-in-Jabalpur",
  },
  {
    title: `IVF Treatment in Jabalpur: Cost, Success Rates & Best Fertility Clinic`,
    author: "Dr. Archana Srivastava",
    date: "12 March, 2025",
    href: "/IVF-Treatment-in-Jabalpur-Cost-Success-Rates-Best-Fertility-Clinic",
  },
  {
    title: `Struggling with Infertility? Meet the Best IUI Center and best infertility doctors in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "01 March, 2025",
    href: "/Struggling-with-Infertility-Meet-the-Best-IUI-Center-and-best-infertility-doctors-in-Jabalpur",
  },
  {
    title: `Egg Freezing in Jabalpur – Best Fertility Treatment : Jabalpur IVF Center`,
    author: "Dr. Archana Srivastava",
    date: "24 February, 2025",
    href: "/Egg-Freezing-in-Jabalpur-Best-Fertility-Treatment",
  },
  {
    title: `Difference Between IVF and IUI Treatments : Best IVF Doctor in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "17 February, 2025",
    href: "/Difference-Between-IVF-and-IUI-Treatments-Best-IVF-Doctor-in-Jabalpur",
  },
  {
    title: `Best Infertility Doctor In Jabalpur : Dr. Archana Shrivastav`,
    author: "Dr. Archana Srivastava",
    date: "11 February, 2025",
    href: "/Best-Infertility-Doctor-in-Jabalpur-Dr.Archana-Shrivastav-Jabalpur-Fertility-Centre",
  },
  {
    title: `Best IVF Doctor in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "29 January, 2025",
    href: "/Best-IVF-Doctor-in-Jabalpur-Dr.Archana-Shrivastav",
  },
  {
    title: `Best IVF Specialist in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "29 January, 2025",
    href: "/Dr.Archana-Shrivastav-Best-IVF-Doctor-in-Jabalpur-Madhya-Pradesh",
  },
  {
    title: `Infertility Treatment Doctor Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "15 January, 2025",
    href: "/Infertility-Treatment-Doctor-Jabalpur",
  },
  {
    title: `Best Infertility Treatment Doctor in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "5 January, 2025",
    href: "/Best-Infertility-Treatment-Doctor-in-Jabalpur",
  },
  {
    title: `Best Infertility Doctors for Male in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "14 December, 2024",
    href: "/Best-Male-Infertility-Treatment-in-Jabalpur",
  },
  {
    title: `Best Oligospermia Treatment in Jabalpur`,
    author: "Dr. Archana Srivastava",
    date: "28 November, 2024",
    href: "/Best-Oligospermia-Treatment-in-Jabalpur",
  },
  
];

export default function Sidebar() {
  return (
    <div className="cs_sidebar">

      <div className="cs_sidebar_item">
        <RecentPostWidget title="Popular Articles" data={recentPostData} />
      </div>
    </div>
  );
}
// 